import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Button, Divider, Drawer, Flex, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import type { IHelperPage } from 'v2/interfaces/helperPage';
import { helperPagesFactory } from 'v2/services/helperPage';

import NoDangerouslyHTML from '../NoDangerouslyHTML';

const HelperPage = ({ title, name, id }: { title: string; name: string; id: string }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [openHint, setOpenHint] = useState<boolean>(false);
  const [helpers] = useObservable(() => helperPagesFactory.loadHelperPage(name), []);
  const [currentHint, setCurrentHint] = useState<IHelperPage>(null);

  const onClose = () => {
    setOpen(false);
    setOpenHint(false);
    setCurrentHint(null);
  };

  if (!helpers?.length) return null;

  return (
    <>
      <Button id={id} onClick={() => setOpen(true)} icon={<Icon.CircleHelp  />}>
        Ajuda
      </Button>

      <Drawer
        placement='right'
        open={open}
        onClose={onClose}
        title={
          <Flex align='center' justify='space-between'>
            <Typography.Text strong>{title}</Typography.Text>
            <Button type='text' icon={<Icon.X  />} onClick={onClose} aria-label='Fechar ajuda' />
          </Flex>
        }
        closable={false}
        width={500}
      >
        {openHint && (
          <div className='flex cursor-pointer items-center px-4 pt-4 pb-0' onClick={() => setOpenHint(false)}>
            <Button icon={<Icon.ArrowLeft  />} type='text'>
              Voltar para lista
            </Button>
          </div>
        )}
        <div className='max-w-125 overflow-x-hidden max-md:max-w-full'>
          {openHint ? (
            <div className='p-4 text-sm'>
              <Typography.Title level={5}>{currentHint.name}</Typography.Title>
              <NoDangerouslyHTML html={currentHint.hint} />
            </div>
          ) : (
            (helpers || []).map(h => (
              <>
                <div
                  key={h.name}
                  onClick={() => {
                    setCurrentHint(h);
                    setOpenHint(true);
                  }}
                  className='flex cursor-pointer items-center justify-between p-4 text-base'
                >
                  <Typography.Text>{h.name}</Typography.Text>
                  <Button type='text' icon={<Icon.ChevronRight  />} aria-label={`Abrir ${h.name}`} />
                </div>
                <Divider className='my-0!' />
              </>
            ))
          )}
        </div>
      </Drawer>
    </>
  );
};

export default HelperPage;
